if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                this.handleErrorMessage();

        const duplicateBlocked = await this.blockDuplicateProductAdd();
        if (duplicateBlocked) return;

        const mutexBlocked = await this.blockMutexCollection();
if (mutexBlocked) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
  window.location.href = window.routes.cart_url;
  return;
}

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }
            async blockDuplicateProductAdd() {
        const productId = this.getCurrentProductId();
        const variantId = this.variantIdInput?.value;
        const formCategory = this.form.querySelector('[name="properties[_bf_category]"]')?.value;

        if (!productId) return false;

        try {
          const response = await fetch(`${window.routes.cart_url}.js`, {
            headers: { Accept: 'application/json' },
          });

          if (!response.ok) return false;

          const cart = await response.json();
          if (!Array.isArray(cart.items)) return false;

          let hasDuplicate = false;

          if (formCategory === 'sale') {
            hasDuplicate = cart.items.some(
              (item) => String(item.variant_id) === String(variantId)
            );
          } else {
            hasDuplicate = cart.items.some(
              (item) => String(item.product_id) === String(productId)
            );
          }

          if (!hasDuplicate) return false;

          this.handleErrorMessage(
            this.dataset.bfDuplicateProductMessage || 'This product is already in your cart.'
          );
          return true;
        } catch (error) {
          console.error(error);
          return false;
        }
      }

              async blockMutexCollection() {
        try {
          const response = await fetch(`${window.routes.cart_url}.js`, {
            headers: { Accept: 'application/json' },
          });

          if (!response.ok) return false;

          const cart = await response.json();
          const currentPath = window.location.pathname.toLowerCase();
          

          const isPaymentProduct =
            currentPath.includes('/reservation-deposit') ||
            currentPath.includes('/expedite');

          if (isPaymentProduct) return false;

          const formCategory = this.form.querySelector('[name="properties[_bf_category]"]')?.value;

const isNewMattressProduct = formCategory === 'sale';

          let cartHasNewMattress = false;
          let cartHasRentalFurniture = false;

          if (Array.isArray(cart.items)) {
            cart.items.forEach((item) => {
              const handle = String(item.handle || '').toLowerCase();

              const itemIsPaymentProduct =
                handle.includes('reservation-deposit') ||
                handle.includes('expedite');

              if (itemIsPaymentProduct) return;

             const itemIsNewMattress =
  item.properties &&
  item.properties._bf_category === 'sale';

              if (itemIsNewMattress) {
                cartHasNewMattress = true;
              } else {
                cartHasRentalFurniture = true;
              }
            });
          }

          const shouldBlock =
            (isNewMattressProduct && cartHasRentalFurniture) ||
            (!isNewMattressProduct && cartHasNewMattress);

          if (!shouldBlock) return false;

          this.handleErrorMessage(
            this.dataset.bfMutexMessage
          );
          return true;
        } catch (error) {
          console.error(error);
          return false;
        }
      }

      getCurrentProductId() {
        const productInfo = this.closest('product-info');
        if (productInfo && productInfo.dataset.productId) return productInfo.dataset.productId;

        const container = this.closest('[data-product-id]');
        if (container && container.dataset.productId) return container.dataset.productId;

        return null;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
  if (disable) {
    this.submitButton.setAttribute('disabled', 'disabled');
    if (text) this.submitButtonText.textContent = text;
  } else {
    this.submitButton.removeAttribute('disabled');

    const formCategory = this.form.querySelector('[name="properties[_bf_category]"]')?.value;

    if (formCategory === 'sale') {
      // 什么都不做 → 保持 Liquid 的 Buy Now
    } else {
      this.submitButtonText.textContent = window.variantStrings.addToCart;
    }
  }
}

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
